export const UNKNOWN_ERROR = 'unknown_error';
export const VALIDATION_ERROR = 'validation_error';
